const NotificationService = function (toastr) {
  "ngInject"
  
  const warning = (message) => {
      toastr.warning(message);
  }
  
  const success = (message) => {
      toastr.success(message);
  }
  
  const error = (message) => {
      toastr.error(message);
  }
   
  return { warning, success, error };
};

export default NotificationService;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/notification.service.js
 **/